import { load } from 'cheerio';
import Provider from '@/enums/Provider';

export function extractCategoryName(
    htmlSource: string,
    pathname: string,
    provider: Provider
): string {
    const $ = load(htmlSource);
    let name = '';

    switch (provider) {
        case Provider.KBS:
            $('a[href="' + pathname + '"]').each((i, element) => {
                name = $(element).text().trim();
                if (name) return false; // Break out after the first match
            });

            // Fallback: generate name from URL if no name found
            if (!name) {
                const pathParts = pathname.split('/').filter(Boolean);
                const lastPart = pathParts[pathParts.length - 1];
                if (lastPart) {
                    // Remove file extension and convert hyphens/underscores to spaces
                    name = lastPart.replace(/\.(php|html?)$/i, '')
                                   .replace(/[-_]/g, ' ')
                                   .split(' ')
                                   .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                   .join(' '); // Proper title case
                }
            }
            break;
        case Provider.IO:
            name = $('h1.catNameIO').first().clone().children().remove().end().text().trim();
            break;
        case Provider.ERS:
            // First, try to get the category name from the visible font with an autocolor attribute.
            name = $('font[autocolor="bgtext"]').first().text().trim();

            // If that fails, search for all font elements with class "category_text" and choose the one that is not just "Category:".
            if (!name) {
                $('font.category_text').each((i, element) => {
                    const text = $(element).text().trim();
                    if (text && text !== 'Category:') {
                        name = text;
                        return false; // Break out of the loop once a match is found.
                    }
                });
            }

            // Fallback: use the last part of the pathname (e.g. /category/water_slides/ becomes "water slides").
            if (!name) {
                name = pathname.split('/').filter(Boolean).pop()?.replace(/_/g, ' ') || '';
            }
            break;
        default:
            break;
    }
    return name;
}